import fetch from "auth/FetchInterceptor";

const userRoleService = {};

userRoleService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/user-role",
		method: "get",
		params,
	});

	// return (
	// 	[
	// 		...Array(30).keys()
	// 	].map((i) => ({
	// 		id: i,
	// 		nome: `Setor ${i}`,
	// 	}))
	// );
};

userRoleService.post = function (data) {
	return fetch({
		url: "/v1/rest/user-role",
		method: "post",
		data: data,
	});
};

userRoleService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/user-role/${id}`,
		method: "put",
		data: data,
	});
};

userRoleService.getById = function (id) {
	return fetch({
		url: `/v1/rest/user-role/${id}`,
		method: "get",
	});
};

userRoleService.delete = function (id) {
	return fetch({
		url: `/v1/rest/user-role/${id}`,
		method: "delete",
	});
};

export default userRoleService;
